<template>
    <div class="bodyCabecalho">
        <b-modal ref="add-novo-cabecalho"
        size="md"
        centered
        title="Adicionar itens para o cabeçalho"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        body-class="rounded-bottom-1rem "
        content-class="rounded-1rem"
        >
        <template #modal-title>
            <div class="header-title">Adicionar itens para o cabeçalho</div>
        </template>
            <div class="container-new-template">
                <div class="search-container"  v-if="cadastros === false">
                    <i class="fas fa-search icone-search"></i>
                    <input v-model="buscaItem" class="input-pesquisar" placeholder="Pesquisar Item"/>
                </div>
                <p class="sublinhado" @click="ItemNovoParaLita" v-if="cadastros === false">Adicionar novo item a lista</p>

                <div class="container-add-itens"  v-if="cadastros === true">
                  <label class="labelsearch margem">Descrição</label>
                  <input v-model="novoItemDescricao" class="input-descricao" placeholder="Descrição Item"/>

                  <label class="labelsearch margem">Status do Template</label>
                  <select v-model="novoItemTipo" name="statusTipo" class="form-control" id="exampleFormControlSelect2">
                      <option :value = null disabled>Selecione o Tipo</option>
                      <option v-for="data in statusCabecalho" v-bind:key="data.value" :value="data.value">{{data.text}}</option>
                  </select>

                </div>

                <div class="container-add-itens" v-if="cadastros === false">
                <div class="itens"  v-for="data in dataFiltroQMACabecalho" v-bind:key="data.id" >
                    <div class="nome-itens">
                      <img class="img_tipo_campo" :src="data.tipo === 0 ? imgTexto : data.tipo === 1 ? imgNumero : imgData" v-b-tooltip.hover :title="data.tipo  === 0 ? 'Campo Texto' : data.tipo === 1 ? 'Campo Número' : 'Campo Data'">
                      {{ data.descricao }}
                    </div>
                    <div class="button-epi-selecionado">
                        <div class="button" :id="data.id" @click="AdicionarIten(data)"><i class="fas fa-plus icone-add"></i></div>
                    </div>
                </div>
                </div>
                <div class="d-flex container_cancel_save">
                    <div class="cancelar">
                        <button class="button-cancel" @click="fecharPopUptAdd">CANCELAR</button>
                    </div>
                    <div class="criar">
                        <button v-if="cadastros === false" class="button-save" @click="identificarElementosClicados">ADICIONAR</button>
                        <button v-if="cadastros === true" class="button-save" @click="validaCampos">CADASTRAR</button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import newHeader from './newHeader'
export default newHeader
</script>

    <style scoped>
    .container_img {
      display: flex;
      justify-content: center;
      width: 100%;
    }
    .img_tipo_cadastro {
      margin: 2rem 0 1rem 0;
      width: 13%;
    }
    .img_semDados {
      display: flex;
      justify-content: center;
      width: 100%;
    }
    .sublinhado {
      width: 100%;
      font: normal normal 600 13px/21px Segoe UI;
      text-align: center;
      color: #008144;
      text-decoration: underline;
      margin-bottom: 1rem;
    }
    .img_tipo_campo {
      width: 34px;
      padding-left: 0.5rem
    }
    .header-title{
      color: white;
      font-weight: bold;
      font-size: 16px;
      font-family: 'Segoe UI';
    }
    .bodyCabecalho{
      width: 100%;
    }
    .nome-itens{
      gap: 1rem;
      color: #747474;
      font-size: 13px;
      font-family: 'Segoe UI';
      width: 100%;
      display: flex;
      align-items: center;
    }
    .container-add-itens{
      width: 100%;
      height: fit-content;
      border-bottom: 1px solid rgb(233, 233, 233);
      height: 15rem;
      overflow: auto;
      border-bottom: 1px solid #D4D4D4;
      border-radius: 10px;
    }
    .container-add-itens::-webkit-scrollbar-track {
      background-color: #F4F4F4;
      border-radius: 10px;
    }
    .container-add-itens::-webkit-scrollbar {
        width: 6px;
        background: #F4F4F4;
        border-radius: 10px;
    }
    .container-add-itens::-webkit-scrollbar-thumb {
        background: #dad7d7;
        border-radius: 10px;
    }
    .itens {
      border-top: 1px solid  rgb(233, 233, 233);
      width: 100%;
      display: flex;
      height: 3rem;
      width: 100%;
    }
    .button-epi-selecionado{
      display: flex;
      width: 10%;
      margin-bottom: 2rem;
      justify-content: initial;
    }
    .button{
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgb(216, 216, 216);
      width: 1.3rem;
      height: 1.3rem;
      border-radius: 50%;
    }
    .button.clicked {
          background-color: #008144; /* Cor de fundo alterada */
     }
    .icone-add {
      color: white;
      font-size: 11px;
    }
   .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1.5rem;
    column-gap: 20px;
   }
   .button-cancel{
     background-color: #b60000;
     color: white;
   }
   .button-save{
    background-color: darkgreen;
    color: white;
   }

  .button-cancel,
  .button-save{
    margin-top: 10;
    font-size: 12PX;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }
  .input-pesquisar{
      width: 100%;
      margin-top: 0.5rem;
      height: 2rem;
      border: 1px solid rgb(216, 216, 216);
      border-radius: 2px;
      padding-left: 2rem;
      margin-bottom: 1rem;
  }
  .input-descricao{
      width: 100%;
      margin-top: 0.5rem;
      height: 2rem;
      border: 1px solid rgb(216, 216, 216);
      border-radius: 2px;
      padding-left: 17px;
      margin-bottom: 1rem;
  }
  .icone-search{
      position: absolute;
      left: 10px;
      top: 18px;
      font-size: 14px;
  }
  .search-container {
    position: relative;
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/newHeader/newHeader.vue